export default __webpack_public_path__ + "static/media/DSC_7576.b0e0b59d.jpg";